"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ControlTextarea;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

var _excluded = ["id", "onChange", "value", "label", "optional", "aside", "validationError", "noAuto", "themeControlTextarea", "themeControlWrapper", "themeLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propNames = ['id', 'value', 'onChange', 'label', 'noAuto', 'optional', 'aside', 'validationError', 'themeControlTextarea', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

function ControlTextarea(_ref) {
  var id = _ref.id,
      _onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      label = _ref.label,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      aside = _ref.aside,
      validationError = _ref.validationError,
      _ref$noAuto = _ref.noAuto,
      noAuto = _ref$noAuto === void 0 ? false : _ref$noAuto,
      _ref$themeControlText = _ref.themeControlTextarea,
      themeControlTextarea = _ref$themeControlText === void 0 ? 'textarea hmin120' : _ref$themeControlText,
      themeControlWrapper = _ref.themeControlWrapper,
      themeLabel = _ref.themeLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  var extraProps = (0, _omit.default)(props, propNames);
  var textareaProps = {
    id: id,
    name: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value, id);
    },
    value: value,
    className: themeControlTextarea,
    'aria-required': optional ? false : true,
    'data-testid': "".concat(id, "-textarea")
  };

  if (noAuto) {
    textareaProps.autoCapitalize = 'none';
    textareaProps.autoCorrect = 'off';
    textareaProps.spellCheck = false;
  }

  if (validationError) {
    textareaProps['aria-invalid'] = true;
  }

  return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
    themeControlWrapper: themeControlWrapper,
    id: id,
    validationError: validationError
  }, label && /*#__PURE__*/_react.default.createElement(_controlLabel.default, {
    text: label,
    id: id,
    aside: aside,
    optional: optional,
    themeLabel: themeLabel
  }), /*#__PURE__*/_react.default.createElement("textarea", _extends({}, textareaProps, extraProps)));
}

ControlTextarea.propTypes = {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string,

  /** The control's value. */
  value: _propTypes.default.string,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments: the new value, and the `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** Label for the control. */
  label: _propTypes.default.string,

  /** If `true`, autocorrect and spelling suggestions will be disabled. */
  noAuto: _propTypes.default.bool,

  /** If `true`, the text `(optional)` is appended to the label element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** A validation error to display beneath the control. */
  validationError: _propTypes.default.node,

  /** Classes to apply to the textarea element. */
  themeControlTextarea: _propTypes.default.string,

  /** Classes to apply to the control wrapper. */
  themeControlWrapper: _propTypes.default.string,

  /** Classes to apply to the label element. */
  themeLabel: _propTypes.default.string
};